import VideoManager from './VideoManager'

export default VideoManager
// eslint-disable-next-line import/export
export * from './VideoManager'
